module.exports = __webpack_public_path__ + "static/img/info-nps.9eac3d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info-nps.png
// module id = 55sI
// module chunks = 1